// lastSeenStore — how far you have read a conversation, so the chat can say
// "New since you were here" (pen "Chat – every entry" §9). Per conversation,
// on this device: view state, never domain state (reading is not a fact the
// log records), like formDraftStore and tourSeen. The stored value is the
// newest message instant the thread showed you (epoch ms).

import { readDeviceKey, writeDeviceKey } from "./deviceStore.js";

const keyFor = (conversationId: string): string =>
    `bilda.chatLastSeen.${conversationId}`;

// Parse, don't validate: anything but a positive whole number is "never".
export const parseLastSeen = (raw: string | null): number | undefined => {
    const n = raw === null ? Number.NaN : Number(raw);
    return Number.isInteger(n) && n > 0 ? n : undefined;
};

export const readLastSeen = (conversationId: string): number | undefined =>
    parseLastSeen(readDeviceKey(keyFor(conversationId)));

export const writeLastSeen = (conversationId: string, at: number): void => {
    writeDeviceKey(keyFor(conversationId), String(at));
};
